import { useRoutes } from "react-router-dom"

import GuestRoutes from "./GuestRoutes"
import AdminRoutes from "./AdminRoutes"

// ==============================|| ROUTES RENDER ||============================== //

export default function AppRoutes() {
    return useRoutes([GuestRoutes, AdminRoutes])
}
